import './App.css';
import { BrowserRouter, Navigate } from 'react-router-dom';
import React, { Component } from 'react';
import MainLayout from './components/Layout';
import Side from './components/Side';

import routes from './routes';
import { convertRoutes, RegisterIframeMessage } from './utils';
import actions from './actions';
import { inject, observer } from 'mobx-react';
import { toJS } from 'mobx';
import { ConfigProvider } from 'antd';
import { Route, Routes } from 'react-router-dom';
import RequireAuth from '@/router/RequireAuth';
import ConstantRoutes from '@/router/ConstantRoutes';
import { getSide } from './api/menu';
import zhCN from 'antd/es/locale/zh_CN';
import 'font-awesome/css/font-awesome.min.css';
import { loginBurialPoint } from './utils/buryPoint';

const { iframeApp } = convertRoutes(routes),
    registerMessage = new RegisterIframeMessage(iframeApp);

@inject('store')
@observer
class App extends Component {
    async componentDidMount() {
        await this.initAction();
        const {
            store: { login }
        } = this.props;

        await login.getCurTenantInfo();
        await login.fetchRegisteredStatus();
        this.initLoginPoint();
    }
    initAction = async () => {
        let defaultSide = {},
         defaultSideOther = {};
        const noAuthRoutes = ConstantRoutes.map((ele) => ele.resource_path),
            { global, menu, login } = this.props.store;
        actions.onGlobalStateChange((state) => {
            global.setShareGlobalData(state);
            let message = toJS(state);

            registerMessage.emitMessage(message);
        }, true); //onGlobalStateChange的第二个参数设置为true，则会立即触发一次观察者函数
        const pathname = window.location.pathname,
        // 启航杯逻辑
         isQhbLogin = /\/(2025|2026)_(region|city)_qhb_login/.test(pathname);
        if ((pathname !== '/' && noAuthRoutes.includes(pathname))
            || pathname.includes('/share-link') || isQhbLogin) {
            return false;
        }
        await login.getAdminUserInfo();
        menu.getOpers();
        let res = (await getSide()) || {}, //获取当前租户，有哪些端的权限
            sides = res.data || [];

        global.setState('sides', sides);

        /**一、不需要鉴权的路由
             1、获取pathname的第一个值记为端side，如果side在ConstantRoutes中的resource_path中，return
        二、需要鉴权的路由
         1、查询该租户拥有哪些端的权限 记为sides
         2、当pathname不存在时 此时的pathname为'/'
            a、遍历sides注册子应用，并通过sides中默认端的id请求菜单，以及设置默认的tenantPlatform
         3、当pathname存在时
            a、如果side不在sides中，不做任何操作
            b、如果side在sides中，则直接遍历sides注册子应用，并通过sides中side的id请求菜单,以及设置默认的tenantPlatform
*/
        //不存在pathName时，
        if (pathname === '/') {
            defaultSide = sides.find((ele) => ele.default_state === 1);
            defaultSideOther = sides.find((ele) => ele.default_state === 0);
        } else {
            let pathSide = pathname.split('/')[1],
                sideIndex = sides.findIndex((ele) => ele.side_url === pathSide);
            if (sideIndex === -1) {
                return false;
            }
            defaultSide = sides[sideIndex];
            defaultSideOther=sides.find((ele) => ele.default_state !== defaultSide.default_state);//角色管理页面资源需要反向查询
        }
        if (defaultSide && defaultSide.id) {
            // document.title = defaultSide.side_name;

            global.setPlatform(defaultSide);
            menu.fetchMenuList(defaultSide);
        }
        if (defaultSideOther && defaultSideOther.id) {
            global.setPlatformOther(defaultSideOther);
        }
    };
    initLoginPoint = async () => {
        const { login } = this.props.store;
        let data = {
            tenant_id: login.tenantInfo.id,
            uid: login.userInfo.id
        };
        if (data.tenant_id && data.uid) {
            loginBurialPoint(data);
        }
    };
    render() {
        const { menu, global, login } = this.props.store,
            { platform,shareGlobalData } = global,
            { tenantInfo } = login,
            { side_url = null } = platform,
            { userInfo } =shareGlobalData;

        return (
            <BrowserRouter>
                <ConfigProvider prefixCls="main" locale={zhCN}>
                    <Routes>
                        {side_url ? (
                            <Route path={'/' + side_url + '/'} key={side_url} element={<MainLayout platform={platform} />}>
                                {menu.routes.map((v) => (
                                    <Route
                                        path={v.resource_path}
                                        key={v.resource_path}
                                        element={<RequireAuth menuStore={menu} {...v}></RequireAuth>}
                                    />
                                ))}
                                <Route path={'/' + side_url + '/'} key={'/'} element={<Side side={platform} tenantInfo={tenantInfo} userInfo={userInfo}/>} />
                            </Route>
                        ) : null}
                        {ConstantRoutes.map((v) => (
                            <Route path={v.resource_path} key={v.resource_path} element={v.element} />
                        ))}

                        {/* 避免异步，数据还没过来就已经重定向了 */}
                        {side_url ? <Route path="/" key="index" element={<Navigate to={'/' + side_url} />} /> : null}
                    </Routes>
                </ConfigProvider>
            </BrowserRouter>
        );
    }
}

export default App;
